import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as NavBack } from '../../../assets/img/storage/nav-back.svg';
import { ReactComponent as Sep } from '../../../assets/svg/Separator.svg';

export interface BreadcrumbItemProps {
    href: string,
    icon?: ReactNode,
    label?: string,
    active?: boolean,
}

function StorageSep() {
    return (
        <span className="storage__main-header-path-sep">
            <Sep />
        </span>
    )
}

interface StorageBreadcrumbProps {
    items: BreadcrumbItemProps[],
    firstLink?: boolean,
    children?: ReactNode,
}

function StorageBreadcrumb({ items, firstLink, children }: StorageBreadcrumbProps) {
    const preItems = items.slice(0, -1);
    const preCount = preItems.length;
    const lastItem = items[items.length - 1];

    return (<div className="storage__main-header">
        {preCount > 0 && (
            <div className="storage__main-header-path">
                {preItems.map((item, i) => <React.Fragment key={i}>
                    <Link to={item.href}>{item.label}</Link>
                    {i < (preCount - 1) && <StorageSep />}
                </React.Fragment>)}
            </div>
        )}
        {lastItem && (
            <div className="storage__main-header-heading">
                {(firstLink || preCount > 0) ?
                    <Link to={preItems[preCount - 1].href}>
                        <NavBack />
                        {lastItem.label}
                    </Link>
                    :
                    <div className="storage__main-header-heading">{lastItem.label}</div>
                }
            </div>
        )}
        {children}
    </div>);
}

export default StorageBreadcrumb;